// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconBlock_icon__2bSn2"};